export default function TownHandbook() {
  return (
    <iframe
      title="town handbook"
      className="doc"
      src="https://docs.google.com/document/d/e/2PACX-1vTkinZcy-HHs-6x2oF_iE_WNhKM5zCOyD0ECtj-jy96NbjDS3YJjWehJl7u_9pyy0PYQKoBoSLN7nDi/pub?embedded=true"
    />
  )
}
